import React, { useEffect, useRef } from 'react';
import { config } from '@shakkerai/config';
import { useLoadingHooks } from '@shakkerai/pro-hooks';
import { LoadingOverlay } from '@mantine/core';
import { notifyError } from '@shakkerai/pro-components';

const getTargetLoginUrl = (isLocal = false) => {
  const searchParams = new URLSearchParams(window.location.search);
  // 百度
  const bd_vid = searchParams.get('bd_vid');
  // bilibili
  const track_id = searchParams.get('track_id');
  let adSuffix = '';
  if (bd_vid) {
    adSuffix = `&bd_vid=${bd_vid}`;
  }
  if (track_id) {
    adSuffix = `&track_id=${track_id}`;
  }

  if (isLocal) {
    return 'http://localhost:3001/login';
  } else if (config.name === 'test') {
    return `https://www-test.liblib.art/login?platform=picpic${adSuffix}`;
  } else if (config.name === 'pre') {
    return `https://www-pre.liblib.art/login?platform=picpic${adSuffix}`;
  } else if (config.name === 'online') {
    // const domain = getTopLevelDomain(window.location.origin); // 获得liblib.art/
    return `https://www.liblib.art/login?platform=picpic${adSuffix}`;
  }
};

/**
 * Lib的登录弹窗
 * @returns
 */
export const LibLogin = ({ onClose: closeModal, visible }) => {
  const { isLoading, setLoadingState, setSuccessState, setFailState } = useLoadingHooks();

  const timeoutHandler = useRef();

  useEffect(() => {
    if (visible) {
      setLoadingState();

      timeoutHandler.current = setTimeout(() => {
        closeModal && closeModal();

        notifyError('资源未能成功加载');
        setFailState();
      }, 15000);

      const messageListener = async (event) => {
        try {
          if (!event.data) return;
          const parseResult = typeof event.data === 'object' ? event.data : JSON.parse(event.data);
          if (parseResult.type === 'onLoginClose') {
            closeModal && closeModal();
          } else if (parseResult.type === 'onLoginPageLoadFinish') {
            setSuccessState();
            // 取消超时动作
            if (timeoutHandler.current) {
              clearTimeout(timeoutHandler.current);
            }
          }
        } catch (error) {
          // 正常情况下忽略错误
        }
      };

      window.addEventListener('message', messageListener);

      return () => {
        window.removeEventListener('message', messageListener);
      };
    } else {
      return () => {};
    }
  }, [visible, closeModal, setLoadingState, setSuccessState, setFailState]);

  if (visible) {
    return (
      <>
        <LoadingOverlay visible={isLoading} zIndex={1000} />
        <iframe
          src={getTargetLoginUrl(false)}
          frameBorder={0}
          style={{
            width: '100%',
            height: '100%',
            background: 'transparent',
          }}
        ></iframe>
      </>
    );
  } else {
    return null;
  }
};
